// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5e30dc0e","796":"764fc02f"}[chunkId] + ".chunk.js";
};